import type { ReactNode } from 'react';

import { cx } from '@/shared/lib/cx';

import styles from './EmptyState.module.scss';

export interface EmptyStateProps {
  /** Иконка из lucide — крупная, приглушённая. */
  icon?: ReactNode;
  title: ReactNode;
  /** Что делать дальше — не «пусто», а «создайте первую задачу». */
  description?: ReactNode;
  /** Кнопка действия — обычно одна, `Button` из shared/ui. */
  action?: ReactNode;
  /** Компактный — внутри панелей и колонок, а не на весь экран. */
  compact?: boolean;
  className?: string;
}

/**
 * Пустое состояние.
 *
 * Появляется там, где список ещё пуст, и говорит не «ничего нет», а что
 * сделать, чтобы стало. Заголовок — Unbounded: это одно из немногих мест,
 * где крупный акцидентный шрифт уместен.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  compact = false,
  className,
}: EmptyStateProps) {
  return (
    <div className={cx(styles['empty'], compact && styles['empty--compact'], className)}>
      {icon !== undefined && icon !== null && (
        <div className={styles['empty__icon']} aria-hidden="true">
          {icon}
        </div>
      )}
      <h2 className={styles['empty__title']}>{title}</h2>
      {description !== undefined && description !== null && (
        <p className={styles['empty__text']}>{description}</p>
      )}
      {action !== undefined && action !== null && (
        <div className={styles['empty__action']}>{action}</div>
      )}
    </div>
  );
}
